import { render, staticRenderFns } from "./phone_after_free_payment.vue?vue&type=template&id=9d8a6d52&"
import script from "./phone_after_free_payment.vue?vue&type=script&lang=js&"
export * from "./phone_after_free_payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports